export default `
  getPoi(cityId: $cityId) {
    lat
    lng
    name
    placeId
  }
`;
